import { render, staticRenderFns } from "./FaqsItem.vue?vue&type=template&id=6677e804&"
import script from "./FaqsItem.vue?vue&type=script&lang=js&"
export * from "./FaqsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports